import { attr, hasOne } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';

const ContactPreferences = ApplicationRecord.extend({
  attrs: {
    email_marketing_opt_in: attr(),
    post_marketing_opt_in: attr(),
    sms_marketing_opt_in: attr(),
    phone_marketing_opt_in: attr(),
    third_party_marketing_opt_in: attr(),
    push_notification_marketing_opt_in: attr(),
    customer: hasOne({ type: 'customers-customers', persist: false }),
  },
  static: {
    jsonapiType: 'customers-contact_preferences',
  },
});

export default ContactPreferences;
